// removed by extract-text-webpack-plugin
    if(module.hot) {
      // 1694697646447
      var cssReload = require("!../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  


//////////////////
// WEBPACK FOOTER
// ./src/components/ItemOrderUpdateModal/styles.scss
// module id = ./src/components/ItemOrderUpdateModal/styles.scss
// module chunks = 0